import React, { useState, useCallback, useEffect, useRef } from 'react';
import { Space, Table, TableProps, Tag, Button } from 'antd';
import { searchHistoryLogs, getDefaultProject } from '../../api/onlineDatas';
import Filter from './Filter'
import { dateTimeRender, parseSearchParams, textRender, downloadFile } from '../../utils';
import { useSearchParams } from 'react-router-dom';
import { apis } from '../../constants';
const { Column } = Table;

const ProjectList: React.FC<{
    showCertain?: {
        projectId: any, devSn: any
    }
}> = ({ showCertain }) => {
    const [downloading, setDownloading] = useState(false)
    const defaultProjectIdFetchedRef = useRef(false);
    const [searchParams] = useSearchParams();
    const initalParams = parseSearchParams<Partial<Omit<SearchLogParams, 'pageNum' | 'pageSize'> & { isHistory?: string }>>(searchParams)
    const [params, setParams] = useState<Partial<Omit<SearchLogParams, 'pageNum' | 'pageSize'>>>({
        ...initalParams,
        ...(
            initalParams.isHistory === '1' ? {} :
                {
                    receivedStartDate: dateTimeRender(new Date().getTime() - 3 * 24 * 60 * 60 * 1000),
                    receivedEndDate: dateTimeRender(new Date().getTime()),
                }
        ),
        switchNumber: initalParams.switchNumber ? Number(initalParams.switchNumber) : undefined,
    });
    const [pagination, setPagination] = useState<Pick<SearchLogParams, 'pageNum' | 'pageSize'>>({
        pageNum: 1,
        pageSize: 10,
    });
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<PagedData<RealtimeData>>({
        pageNum: 1,
        pageSize: 10,
        total: 0,
        data: [],
    });
    const fetchData = useCallback(() => {
        if (defaultProjectIdFetchedRef.current === false) return;
        setLoading(true);
        searchHistoryLogs(showCertain ? { ...showCertain, ...pagination } : { ...params, ...pagination })
            .then(setData)
            .finally(() => { setLoading(false) });
    }, [JSON.stringify(params), pagination, showCertain]);

    useEffect(fetchData, [fetchData]);
    useEffect(() => {
        setParams({
            ...params,
            ...initalParams,
            switchNumber: initalParams.switchNumber ? Number(initalParams.switchNumber) : undefined,
        });
    }, [initalParams.projectId, initalParams.devSn]);
    useEffect(() => {
        if (defaultProjectIdFetchedRef.current === true) return;
        getDefaultProject()
            .then(res => {
                defaultProjectIdFetchedRef.current = true;
                setParams({ ...params, projectId: String(res.projectId) });
            });
    }, [JSON.stringify(params)]);
    return (
        <>
            {showCertain ? null :
                <>
                    <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Filter slot={<Button type='primary' style={{
                            marginLeft: '1em'
                        }} loading={downloading} onClick={() => {
                            setDownloading(true)
                            downloadFile(apis.realtimeDownload, params)
                                .finally(() => {
                                    setDownloading(false)
                                })
                        }}>数据导出</Button>} values={params} onChange={setParams} onSearch={fetchData} />
                    </Space>
                    <br />
                    <br />
                </>
            }
            <HistoryLogTable scroll={{ x: 1 }}
                pagination={{
                    pageSize: pagination.pageSize,
                    current: pagination.pageNum,
                    total: data.total,
                    onChange: (pageNum, pageSize) => {
                        setPagination({
                            ...pagination,
                            pageSize,
                            pageNum
                        })
                    }
                }}
                dataSource={Array.isArray(data.data) ? data.data : []} loading={loading}>
            </HistoryLogTable>
        </>
    );
}

export const HistoryLogTable = (props: TableProps) => {
    return (
        <Table scroll={{ x: 1 }}
            pagination={props.pagination}
            dataSource={props.dataSource}
            loading={props.loading}>
            <Column fixed width={200} title="展会名称" dataIndex="projectName" key="projectName" />
            <Column fixed width={200} title="设备序列号" dataIndex="deviceSn" key="deviceSn" />
            <Column fixed width={200} title="展位号" dataIndex="deviceName" key="deviceName" />
            {/* <Column title="状态"  width={100} render={(alarmStatus: number) => {
                return alarmStatus === 0 ? <Tag color='green'>恢复</Tag> : <Tag color='red'>报警</Tag>
            }} dataIndex="alarmStatus" key="alarmStatus" /> */}
            <Column width={100} title="容量" render={textRender} dataIndex="capacity" key="capacity" />
            <Column width={100} title="设备类型" render={textRender} dataIndex="deviceType" key="deviceType" />
            <Column width={100} title="开关号" render={textRender} dataIndex="switchNumber" key="switchNumber" />
            <Column width={100} title="电流(A)" render={textRender} dataIndex="switchCurrent" key="switchCurrent" />
            <Column width={100} title="功率(W)" render={textRender} dataIndex="switchPower" key="switchPower" />
            <Column width={100} title="电压(V)" render={textRender} dataIndex="switchVoltage" key="switchVoltage" />
            <Column width={100} title="温度(℃)" render={textRender} dataIndex="switchTemp" key="switchTemp" />
            <Column width={140} title="漏电电流(mA)" render={textRender} dataIndex="switchLeakage" key="switchLeakage" />
            <Column width={120} title="A相电流(A)" render={textRender} dataIndex="switchCurrentA" key="switchCurrentA" />
            <Column width={120} title="B相电流(A)" render={textRender} dataIndex="switchCurrentB" key="switchCurrentB" />
            <Column width={120} title="C相电流(A)" render={textRender} dataIndex="switchCurrentC" key="switchCurrentC" />
            <Column width={120} title="N相电流(A)" render={textRender} dataIndex="switchCurrentN" key="switchCurrentN" />
            <Column width={120} title="A相电压(V)" render={textRender} dataIndex="switchVoltageA" key="switchVoltageA" />
            <Column width={120} title="B相电压(V)" render={textRender} dataIndex="switchVoltageB" key="switchVoltageB" />
            <Column width={120} title="C相电压(V)" render={textRender} dataIndex="switchVoltageC" key="switchVoltageC" />
            <Column width={200} title="接收时间" dataIndex="receiveDatetime" key="receiveDatetime" render={time => {
                return dateTimeRender(time)
            }} />
        </Table>
    )
}

export default ProjectList;